import { render, staticRenderFns } from "./WhitePhoneNumbersResComplex.vue?vue&type=template&id=a84ee988&scoped=true"
import script from "./WhitePhoneNumbersResComplex.vue?vue&type=script&lang=js"
export * from "./WhitePhoneNumbersResComplex.vue?vue&type=script&lang=js"
import style0 from "./WhitePhoneNumbersResComplex.vue?vue&type=style&index=0&id=a84ee988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84ee988",
  null
  
)

export default component.exports